import { useEffect } from 'react'
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router'
import { authClient } from '@/lib/auth'
import { Main } from '@/components/layout/main'
import { FormRenderer } from '@/features/forms/renderer/form-renderer'
import { Button } from '@workspace/ui/components/button'
import { ArrowLeft, Printer } from 'lucide-react'

export const Route = createFileRoute(
  '/_authenticated/_organization/forms/$formId/submissions/$submissionId'
)({
  component: SubmissionViewPage,
})

function SubmissionViewPage() {
  const { formId, submissionId } = useParams({ strict: false }) as {
    formId: string
    submissionId: string
  }
  const navigate = useNavigate()
  const { data: activeOrganization, isPending: isLoadingOrganization } =
    authClient.useActiveOrganization()
  const { data: member } = authClient.useActiveMember()

  useEffect(() => {
    if (!isLoadingOrganization && !activeOrganization) {
      navigate({
        to: '/errors/$error',
        params: { error: 'forbidden' },
        state: {
          message:
            'No organization found. Please create an organization first and wait for approval.',
        } as any,
        replace: true,
      })
    }
  }, [isLoadingOrganization, activeOrganization, navigate])

  if (!activeOrganization) {
    return null
  }

  const goBack = () => {
    if (member?.role === 'client') {
      navigate({ to: '/my-forms' })
    } else {
      navigate({
        to: '/forms/$formId/submissions',
        params: { formId },
      })
    }
  }

  return (
    <Main className='flex flex-1 flex-col gap-4 sm:gap-6'>
      <div className='flex items-center justify-between print:hidden'>
        <Button variant='ghost' size='sm' onClick={goBack}>
          <ArrowLeft className='mr-2 h-4 w-4' />
          {member?.role === 'client' ? 'Back to My Forms' : 'Back to Submissions'}
        </Button>
        <Button
          variant='outline'
          size='sm'
          onClick={() => window.print()}
        >
          <Printer className='mr-2 h-4 w-4' />
          Print
        </Button>
      </div>
      <FormRenderer
        formId={formId}
        organizationId={activeOrganization.id}
        mode='view'
        submissionId={submissionId}
        onCancel={goBack}
      />
    </Main>
  )
}
